import { render, staticRenderFns } from "./ProductsAtGlance.vue?vue&type=template&id=d37dd084&"
import script from "./ProductsAtGlance.vue?vue&type=script&lang=js&"
export * from "./ProductsAtGlance.vue?vue&type=script&lang=js&"
import style0 from "./ProductsAtGlance.vue?vue&type=style&index=0&id=d37dd084&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports